import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaDocumentosLayoutsbancariosPendientesLayout', NominaDocumentosLayoutsbancariosPendientesLayout)

function NominaDocumentosLayoutsbancariosPendientesLayout($http) {
  this.get = function (idProyecto, idNomina, idTipoPago, idBanco, idCuenta, fechaPago, interbancario) {
    return $http.get('/api/nominas/nomina/documentos/layoutsbancarios/pendientes/layout', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        id_tipo_pago: idTipoPago,
        id_banco: idBanco,
        id_cuenta: idCuenta,
        fecha_pago: fechaPago.toYMD(),
        interbancario: interbancario ? 1 : 0,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.schema = {
    id_tipo_pago: 'number',
    id_pago: 'number',
    importe: 'number',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Layoutsbancarios/Pendientes/Layout.js